const routes = [
    {
        path: '/comisiones',
        name: 'comisiones',
        props: true,
        component: () => import('../views/comisiones/Comisiones.vue'),
        meta: { requiresAuth: true },

    },
    {
        path: '/liquidaciones/cliente/:cliente',
        name: 'clienteDetalle',
        props: true,
        component: () => import('../views/comisiones/cliente.vue'),
        meta: { requiresAuth: true },

    },
    {
        path: '/liquidaciones/comision/:comision',
        name: 'liquidacionDetalle',
        props: true,
        component: () => import('../views/comisiones/liquidacion.vue'),
        meta: { requiresAuth: true },

    },


    
    {
        path: '/procesar-liquidacion',
        name: 'liquidar',
        props: true,
        meta: { requiresAuth: true },
        component: () => import('../views/comisiones/LiquidarPedidos.vue')
        
    },
    {
        path: '/procesar-liquidacion2/:id_fo_liq',
        name: 'liquidarOCR',
        props: true,
        meta: { requiresAuth: true },
        component: () => import('../views/comisiones/liquidacionOCR.vue')

    },
    
   
    
    {
        path: '/liquidaciones/manuales',
        name: 'operador',
        props: true,
        meta: { requiresAuth: true },
        component: () => import('../views/comisiones/Manuales.vue')
    },
    {
        path: '/informes/operador',
        name: 'informesOperador',
        props: true,
        meta: { requiresAuth: true },
        component: () => import('../views/comisiones/informesOperador.vue')
    },
    {
        path: '/informes',
        name: 'informes',
        props: true,
        meta: { requiresAuth: true },
        component: () => import('../components/admin/informes/index.vue')
    },
    {
        path: '/ayuda',
        name: 'ayuda',
        props: true,
        meta: { requiresAuth: true },
        component: () => import('../views/comisiones/ayuda.vue')
    },
    {
        path: '/liquidacion-detalle/:id_fo_liq',
        name: 'liquidacion-detalle',
        props: true,
        meta: { requiresAuth: true },
        component: () => import('../views/comisiones/liquidacion-detalle.vue')
    },
]

export default routes